import { useState } from 'react';

import BookingsWithReview from './BookingsWithReview'
export default function CustomerreviewPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="CustomerreviewPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <div className="">
                    <div><BookingsWithReview/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
